(function () {
  'use strict';

  if (window.__submissionCartSignupInit) return;
  window.__submissionCartSignupInit = true;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function clean(value) {
    return String(value || '').trim();
  }

  function findWrapper(el) {
    return el.closest('[data-cart-signup-wrapper]');
  }

  function setStatus(wrapper, message, state) {
    var status = wrapper.querySelector('[data-cart-discount-status]');
    if (!status) return;
    status.textContent = clean(message);
    status.classList.toggle('visually-hidden', !clean(message));
    status.classList.toggle('is-visible', Boolean(clean(message)));
    status.dataset.state = state || '';
  }

  function buildSubscriptionPayload(panel, email) {
    var listId = clean(panel.dataset.klaviyoListId);
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          },
          custom_source: 'Cart Drawer Sign-up'
        }
      }
    };

    if (listId) {
      payload.data.relationships = {
        list: {
          data: {
            type: 'list',
            id: listId
          }
        }
      };
    }

    return payload;
  }

  function subscribeToKlaviyo(panel, email) {
    var siteId = clean(panel.dataset.klaviyoSiteId);
    var revision = clean(panel.dataset.klaviyoRevision) || '2026-07-15';
    if (!siteId) return Promise.reject(new Error('Klaviyo public site ID is missing'));

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(siteId), {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        revision: revision
      },
      body: JSON.stringify(buildSubscriptionPayload(panel, email))
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Klaviyo request returned ' + response.status);
      }
      return response;
    });
  }

  function openPanel(trigger, panel) {
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    var input = panel.querySelector('[data-cart-signup-email]');
    if (input) {
      window.requestAnimationFrame(function () {
        input.focus();
      });
    }
  }

  function closePanel(trigger, panel) {
    trigger.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  }

  // NOTE: registered on the CAPTURE phase (the trailing `true`) and calls
  // event.stopPropagation() as soon as a trigger match is confirmed. This
  // theme ships an older, unfinished cart-discount handler compiled into
  // assets/theme.js that also binds to [data-cart-discount-trigger] and
  // calls stopPropagation() during the bubble phase once it starts running
  // (it was built to open a pre-existing Klaviyo pop-up form that isn't
  // configured on this store, so it always falls through to an "unavailable"
  // error). Capturing first and stopping propagation here prevents that
  // legacy handler from ever seeing the click, without touching the
  // compiled bundle.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cart-discount-trigger]');
    if (!trigger) return;
    event.stopPropagation();

    var wrapper = findWrapper(trigger);
    var panel = wrapper ? wrapper.querySelector('[data-cart-signup-panel]') : null;
    if (!panel) return;

    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    if (expanded) {
      closePanel(trigger, panel);
    } else {
      openPanel(trigger, panel);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-cart-signup-form]');
    if (!form) return;
    event.stopPropagation();
    event.preventDefault();

    var panel = form.closest('[data-cart-signup-panel]');
    var wrapper = form.closest('[data-cart-signup-wrapper]');
    if (!panel || !wrapper) return;

    var emailInput = form.querySelector('[data-cart-signup-email]');
    var email = clean(emailInput ? emailInput.value : '').toLowerCase();
    var submitButton = form.querySelector('[data-cart-signup-submit]');

    if (!EMAIL_RE.test(email)) {
      setStatus(wrapper, panel.dataset.invalidEmailMessage, 'error');
      if (emailInput) emailInput.focus();
      return;
    }

    if (submitButton) submitButton.disabled = true;
    if (emailInput) emailInput.disabled = true;
    setStatus(wrapper, panel.dataset.sendingMessage, 'sending');

    subscribeToKlaviyo(panel, email)
      .then(function () {
        setStatus(wrapper, panel.dataset.successMessage, 'success');
        form.hidden = true;
      })
      .catch(function () {
        setStatus(wrapper, panel.dataset.errorMessage, 'error');
        if (submitButton) submitButton.disabled = false;
        if (emailInput) emailInput.disabled = false;
      });
  }, true);
})();
